/**
 * Human names for the recording device, resolved from file_id's manufacturer + product. The FIT
 * garmin_product enum has ~1000 entries; we carry a small curated map of common swim-capable
 * watches and fall back to the manufacturer name (or a numeric hint) so an unknown device never
 * shows a wrong model.
 */
const MANUFACTURERS: Record<number, string> = {
  1: 'Garmin',
  15: 'Dynastream',
  23: 'Suunto',
  32: 'Wahoo',
  38: 'Polar',
  69: 'Coros',
  89: 'Tacx',
  263: 'Bryton',
}

/** Garmin product id → model name (curated; extend as needed). */
const GARMIN_PRODUCTS: Record<number, string> = {
  3905: 'fēnix 7S',
  3906: 'fēnix 7',
  3907: 'fēnix 7X',
  3992: 'Forerunner 255',
  3990: 'Forerunner 255S',
  4257: 'Forerunner 265',
  4258: 'Forerunner 265S',
  4341: 'Forerunner 965',
  3843: 'Forerunner 945 LTE',
  2691: 'Forerunner 945',
  4024: 'Swim 2',
  2859: 'Venu',
  3011: 'Venu Sq',
}

/** A display name for the device, or null when nothing usable is recorded. */
export function deviceName(manufacturer: number | undefined, product: number | undefined): string | null {
  if (manufacturer === undefined || manufacturer === 0 || manufacturer === 0xffff) return null
  const maker = MANUFACTURERS[manufacturer]
  if (manufacturer === 1 && product !== undefined && GARMIN_PRODUCTS[product]) {
    return `Garmin ${GARMIN_PRODUCTS[product]}`
  }
  if (maker) return product && product !== 0xffff ? `${maker} (product ${product})` : maker
  return `Device (manufacturer ${manufacturer})`
}
